import { render, staticRenderFns } from "./rule1.vue?vue&type=template&id=21342416&scoped=true"
import script from "./rule1.vue?vue&type=script&lang=js"
export * from "./rule1.vue?vue&type=script&lang=js"
import style0 from "./rule1.vue?vue&type=style&index=0&id=21342416&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21342416",
  null
  
)

export default component.exports